const config = {
    paginationSize: 4,
    relatedVideosLimit: 5,
    baseAPIUrl: 'https://goldfish-app-28den.ondigitalocean.app/'
};

module.exports = config;
